import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { PlatformComponent } from '../platform.component';

@Component({
  selector: 'app-b103',
  templateUrl: './b103.component.html',
  styleUrls: ['./b103.component.scss', '../platform.component.scss'],
})

/**
 * 会員プロフィール登録完了
 * 会員プロフィール(B211 or B212)へ遷移する
 */
export class B103Component extends PlatformComponent {
  //　会員ID
  memberId: string = this.route.snapshot.queryParams.member_id;
  // 会員種別
  classId: string = this.route.snapshot.queryParams.class_id;

  // 会員情報格納先
  memberInfo: any;

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router
  ) {
    super(route, commonService, dbOperationService, loadingState);
  }

  ngOnInit(): void {}

  /**
   * 会員プロフィール(B211 or B212)へ遷移する
   */
  public moveB211(): void {
    // 会員種別を判定
    // 1:自治体 or 9;事務局の場合
    // 会員プロフィール.会員種別を取得　会員種別に応じてB211 or B212に遷移
    if ('1' == this.classId || '9' == this.classId) {
      // 自治体 or 事務局ユーザの場合
      // 自治体会員プロフィール画面(B211)へ遷移
      this.router.navigate(['pages/platform/b211/' + this.memberId]);
    } else {
      // 3:民間団体の場合
      // B212へ遷移　パスパラメータにメンバーIDをセット
      this.router.navigate(['pages/platform/b212/' + this.memberId]);
    }
  }
}
